import styled from "styled-components";

export const NavContainer = styled.nav`
  justify-items: center;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
  padding-bottom: 10px;
  @media (max-width: 760px) {
    display: none;
  }
`

export const HeaderContainer = styled.header`
  display: grid;
  justify-content: center;
  align-items: center;
  grid-template-columns: 170px 1fr  100px;
  padding: 0 5px 0 5px;
  background: #b3e2ef;
  position: sticky;
  z-index: 100;
top: 0;
  h1 {
    margin: 0;
  }
  
  @media (max-width: 760px) {
    grid-template-columns: 1fr 100px;
  }
`

export const Container = styled.main`
  padding: 0;
  justify-self: center;
  
  max-width: 1400px;
  width: 100%;
`
